import { Box, BoxProps, Flex } from '@chakra-ui/core'
import colors from 'constants/colors'
import React from 'react'
import styles from './RadioCheckbox.module.css'

interface Props extends BoxProps {
  value: string
  isChecked: boolean
  onChange: () => void
  disabled?: boolean
  fillColor?: string
  inputType?: 'checkbox' | 'radio'
  name?: string
}
export const RadioCheckbox: React.FC<Props> = ({
  value,
  isChecked,
  onChange,
  children,
  disabled = false,
  fillColor = colors.greenPoll,
  inputType = 'checkbox',
  name,
  ...props
}) => {
  return (
    <Flex as="label" alignItems="center" style={{ columnGap: '10px' }} mb={0} cursor={disabled ? 'default' : 'pointer'}>
      <Flex as="span" alignItems="center" position="relative" flexShrink={0}>
        <input
          type={inputType}
          name={name}
          value={value}
          aria-label={value}
          checked={isChecked}
          disabled={disabled}
          onChange={onChange}
          className={styles.input}
        />
        <Box
          as="span"
          aria-hidden="true"
          className={styles.indicator}
          width="20px"
          height="20px"
          borderRadius="full"
          borderWidth="1px"
          borderStyle="solid"
          borderColor={isChecked ? fillColor : 'gray.400'}
          backgroundColor={isChecked ? fillColor : 'white'}
          alignItems="center"
          justifyContent="center"
          opacity={disabled ? 0.5 : 1}
          {...props}
        />
      </Flex>

      {children}
    </Flex>
  )
}
